import { Injectable } from '@angular/core';
import { PositionAlignment } from 'devextreme/common';
import { ToastType } from 'devextreme/ui/toast';
import { AbcCoreComponent } from '../abcCoreComponent';
import { AbcCoreContainerService } from '../abcCoreContainer.service';
import { AbcToastComponent } from './abc-toast.component';

@Injectable({
  providedIn: 'root',
})
export class AbcToastService {
  private abcToastComponent: AbcToastComponent;
  private abcToastContainer: AbcCoreComponent;

  constructor(private abcCoreContainerService: AbcCoreContainerService) {
    this.abcToastContainer = this.abcCoreContainerService.createComponent(this.abcToastContainer, AbcToastComponent);
    this.abcToastComponent = this.abcToastContainer.componentRef.instance as AbcToastComponent;
  }

  public async showToast(settings: ToastSettings): Promise<void> {
    this.abcToastComponent.width = settings.width;
    this.abcToastComponent.height = settings.height;
    this.abcToastComponent.position = settings.position;
    this.abcToastComponent.type = settings.type;
    this.abcToastComponent.message = settings.message;
    this.abcToastComponent.visible = true;
    this.abcToastComponent.displayTime = settings.displayTime;

    const domElement = document.getElementsByClassName('dx-toast-content').item(0) as HTMLElement;

    if (settings.position.includes('top')) {
      domElement.style.setProperty('margin', '20px');
    } else if (settings.position.includes('bottom')) {
      domElement.style.setProperty('margin', '-20px');
    }
  }
}

export class ToastSettings {
  width?: string;
  height?: string;
  position?: PositionAlignment = 'center';
  type?: ToastType = 'info';
  message?: string;
  displayTime?: number;
}
